module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'animations/blocks' && templateVars.config ?
				templateVars.config :
				{
	"animationsDuration": false
};